import { registerComponentIcon } from '../utils/registerComponentIcon';
import { TeamsColor as OriginalTeamsColor } from '@fluentui/react-brand-icons';

export const TeamsColor = registerComponentIcon('TeamsColor', OriginalTeamsColor);
